// extracted by mini-css-extract-plugin
module.exports = {"root":"RequestTenantAndBillCard_root__1IUlv","tenant":"RequestTenantAndBillCard_tenant__2D_S6","invoice":"RequestTenantAndBillCard_invoice__3BR41"};